'use strict';

export default function($log, incidents) {
	'ngInject';

	return {
		controller: CalendarController,
		controllerAs: '$calendar',
		link: {
			pre: preLink,
		},
		scope: true,
	};

	function preLink(scope, element, attrs, $ctrl) {
		$ctrl.watch(element);
	}
}

function _fmdate(d) {
	const mo = d.getMonth() + 1;
	const day = d.getDate();
	return d.getFullYear() + '-' + (mo < 10 ? '0' : '') + mo + '-' + (day < 10 ? '0' : '') + day;
}

function _oddate(d, days) {
	return new Date(d.getTime() + days*24*60*60*1000);
}

function _reqDates(start, end, d) {
	if (d < start) {
		return [_oddate(d, -d.getDay()-7), _oddate(start, -1)];
		// When we are not loading to the left, then we must ensure that there are
		// enough dates after the target date that we can put it at the top of
		// the page.
	} else if (d > _oddate(end, d.getDay()-40)) {
		return [_oddate(end, 1), _oddate(d, 41-d.getDay())];
	} else {
		return null;
	}
}

function CalendarController($q, $http, $timeout) {
	'ngInject';
	const vm = {
		now: new Date(),
	};
	// Offset to avoid issues with DST
	vm.now.setHours(12, 0, 0, 0);

	function getDayHeight() {
		if (!vm._dayHeight) {
			vm._dayHeight = document.getElementById(_fmdate(vm.startDate)).offsetHeight;
		}
		return vm._dayHeight;
	}

	function getVisibleSunday() {
		const h = getDayHeight();
		return new Date(vm.days[7*Math.ceil(vm.element.scrollTop/h)].date);
	}

	function updateDisplayDate() {
		vm._updateDD = $timeout(() => {
			const scrollDate = getVisibleSunday();
			vm.visDate = _oddate(scrollDate, 6);
		}, 0);
	}

	function scrollTo(d, offset) {
		if (offset === undefined) offset = 0;
		_ensureLoaded(d).then(() => {
			$timeout(() => {
				const el = document.getElementById(_fmdate(d));
				el.scrollIntoView();
				// This is far from perfect, but the -3 counters the border, that
				// apparently scrollIntoView ignores in modern browsers.
				vm.element.scrollTop += offset - 3;
			}, 0);
		});
	}

	vm.today = scrollTo.bind(null, vm.now);
	vm.prevMonth = function() {
		const t = new Date(vm.visDate.getTime());
		t.setMonth(t.getMonth()-1);
		t.setDate(1);
		scrollTo(t);
	}
	vm.nextMonth = function() {
		const t = new Date(vm.visDate.getTime());
		t.setMonth(t.getMonth()+1);
		t.setDate(1);
		scrollTo(t);
	}

	function checkScroll(e) {
		if (vm.loading) {
			e.preventDefault();
			return;
		}
		const thresh = 500;
		if (vm.element.scrollTop < thresh) {
			_loadDays(_oddate(vm.startDate, -35), _oddate(vm.startDate, -1));
		} else if ((vm.element.scrollHeight - vm.element.scrollTop - vm.element.offsetHeight) < thresh) {
			_loadDays(_oddate(vm.endDate, 1), _oddate(vm.endDate, 35));
		}
		updateDisplayDate();
	}

	vm.watch = function(element) {
		vm.element = element[0];
		vm.element.onscroll = checkScroll;
	}

	function _ensureLoaded(d, deferred) {
		if (!deferred) deferred = $q.defer();
		if (vm.loading) {
			$timeout(() => {
				_ensureLoaded(d, deferred);
			}, 200);
			return deferred.promise;
		}
		const reqDates = _reqDates(vm.startDate, vm.endDate, d);
		if (reqDates) {
			_loadDays(reqDates[0], reqDates[1]).then(deferred.resolve, deferred.reject);
		} else {
			deferred.resolve();
		}
		return deferred.promise;
	}

	vm.refresh = function() {
		if (vm.loading) return;
		const d = getVisibleSunday();
		const h = getDayHeight();
		let offset = (-vm.element.scrollTop % h);
		if (offset !== 0) offset += h;
		vm.startDate = null;
		_loadDays(_oddate(d, -42), _oddate(d, 115), {
			preventScroll: true,
		}).then(() => {
			scrollTo(d, -offset);
		});
	}

	function _loadDays(start, end, options) {
		if (vm.loading) return;
		if (options === undefined) options = {};
		vm.loading = true;
		const response = $http.post('/api/mappy/', {
			query: [
				{
					name: 'calendar_beta',
					args: {
						date_start: _fmdate(start),
						date_end: _fmdate(end),
					},
				},
			],
		})
		response.then((response) => {
			const days = response.data.result.calendar_beta.days;
			if (!vm.startDate) {
				vm.designations = response.data.result.calendar_beta.designations.map((designation) => ({
					name: designation.name,
					selected: true,
				}));
				vm.startDate = start;
				vm.endDate = end;
				vm.viewer = response.data.result.viewer;
				vm.days = days;
				if (!options.preventScroll) $timeout(vm.today, 0);
			} else if (start < vm.startDate) {
				vm.startDate = start;
				if (days.length % 7 !== 0) {
					console.error('Loaded a number of days that is not a multiple of 7!', days.length);
				}
				vm.days = [].concat(days, vm.days)
			} else {
				vm.endDate = end;
				vm.days = [].concat(vm.days, days)
			}
		}).finally(() => {
			vm.loading = false;
			vm.suggestedMultiplier = Math.max(vm.designations.length, 4);
		});;
		return response;
	}

	const iSunday = _oddate(vm.now, -vm.now.getDay()-42);
	_loadDays(iSunday, _oddate(iSunday, 115));

	return vm;
}
